
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./components/HomePage";
import React, { useEffect } from "react";
// Cache busting - Build: 2025-09-06 17:32 UTC
function App() {
  useEffect(() => {
    // Google Tag Manager scriptini ekle
    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-WPNS4D70VE";
    script.async = true;
    document.head.appendChild(script);

    // gtag config kodu
    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    gtag("js", new Date());
    gtag("config", "G-WPNS4D70VE");
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
